/** @jsxImportSource @emotion/react */
import type { ReactNode } from 'react';
import { tableStyle } from './Table.styles';

export interface TableProps {
  /** 머리글 셀 나열. 빈 문자열이면 빈 th 렌더 (액션 열). */
  headers: ReactNode[];
  /** tbody 행(tr) 나열 자리. 행 렌더는 organism 소관. */
  children: ReactNode;
}

/** 표 셸. 모듈 상태·수집 이력·데이터 브라우저의 공통 표 골격에 활용. */
export function Table({ headers, children }: TableProps) {
  return (
    <table css={tableStyle}>
      <thead>
        <tr>
          {headers.map((h, i) => (
            <th key={i}>{h}</th>
          ))}
        </tr>
      </thead>
      <tbody>{children}</tbody>
    </table>
  );
}
